import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import ReactPlayer from "react-player";
import { Img } from "react-image";
import styles from "../../communication-chat.module.css";
import { X, Image as ImageIcon, Film, Mic } from "react-feather";

const getPlaceholderIcon = (contentType) => {
  if (contentType?.startsWith("image/")) return <ImageIcon size={22} />;
  if (contentType?.startsWith("video/")) return <Film size={22} />;
  if (contentType?.startsWith("audio/")) return <Mic size={22} />;
  return null;
};

const MediaItem = ({ file, onOpenFullImage, onMediaLoad }) => {
  const [resolvedUrl, setResolvedUrl] = useState(file.url || null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (resolvedUrl || !file._media) return;
    let cancelled = false;

    file._media
      .getContentTemporaryUrl()
      .then((url) => {
        if (!cancelled) setResolvedUrl(url);
      })
      .catch((e) => {
        console.log("[MEDIA] getContentTemporaryUrl failed", e);
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
    };
  }, [file._media, resolvedUrl]);

  const contentType = file.content_type || "";

  // Still resolving — show a type-appropriate placeholder, no blocking
  if (!resolvedUrl) {
    return (
      <span
        style={{
          width: "160px",
          height: "120px",
          borderRadius: "8px",
          background: "#f5f3fa",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#a48fd1",
        }}
      >
        {failed ? (
          <span style={{ fontSize: "12px", color: "#e23725" }}>
            Failed to load
          </span>
        ) : (
          getPlaceholderIcon(contentType)
        )}
      </span>
    );
  }

  if (contentType.startsWith("image/")) {
    return (
      <div
        onClick={() => onOpenFullImage(resolvedUrl)}
        className={`${styles.ImgFile}`}
      >
        <Img src={resolvedUrl} alt="" onLoad={onMediaLoad} />
      </div>
    );
  } else if (contentType.startsWith("video/")) {
    return (
      <div className={`${styles.ImgFile}`}>
        <ReactPlayer url={resolvedUrl} controls onReady={onMediaLoad} />
      </div>
    );
  } else if (contentType.startsWith("audio/")) {
    return (
      <div className={`${styles.AudioFileContainer}`}>
        <audio src={resolvedUrl} controls onLoadedData={onMediaLoad} />
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "220px",
          maxWidth: "220px",
          overflow: "visible",
          whiteSpace: "normal",
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <p
          className={`${styles.NoFileTT}`}
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            fontSize: "13px",
          }}
        >
          Preview is not available for this file type..
        </p>
        <a
          className={`${styles.NoFileDrBU}`}
          href={resolvedUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "inline-block", marginTop: "6px" }}
        >
          Download File
        </a>
      </div>
    );
  }
};

const IdentityMessageFileViewer = ({ media, onMediaLoad }) => {
  const [fullImageUrl, setFullImageUrl] = useState(null);

  return (
    <>
      {media.map((file, index) => (
        <div key={index}>
          <MediaItem
            file={file}
            onOpenFullImage={setFullImageUrl}
            onMediaLoad={onMediaLoad}
          />
        </div>
      ))}

      {fullImageUrl &&
        ReactDOM.createPortal(
          <div
            className={`${styles.ImgFilePops} ${styles.Active}`}
            onClick={() => setFullImageUrl(null)}
          >
            <Img
              src={fullImageUrl}
              alt=""
              onClick={(e) => e.stopPropagation()}
            />
            <button
              onClick={() => setFullImageUrl(null)}
              className={`${styles.CancelImgBU}`}
            >
              <X />
            </button>
          </div>,
          document.body
        )}
    </>
  );
};

export default IdentityMessageFileViewer;
